import { render, staticRenderFns } from "./edit-trainee.vue?vue&type=template&id=65df0aa6&scoped=true&"
import script from "./edit-trainee.vue?vue&type=script&lang=js&"
export * from "./edit-trainee.vue?vue&type=script&lang=js&"
import style0 from "./edit-trainee.vue?vue&type=style&index=0&id=65df0aa6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65df0aa6",
  null
  
)

export default component.exports